import { required } from 'vuelidate/lib/validators';
import { composeIBAN } from 'ibantools';
import VueMaskedInput from '@ui-common/vue-masked-input';
import VueErrorMessage from '@ui-common/vue-error-message';
import VueButton from '@ui-common/vue-button';
import cdv from '../../../common/js/validators/cdv-validator';
import messages from './../iban-calculator-lang.json';
import { TYPES } from '../iban-calculator';
const DEFAULTS = {
	OTP_PREFIX: 117,
	LAST_DIGITS: '00000000'
};

const transformInput = (accountNumber) => {
	let transformedAccountNumber = DEFAULTS.OTP_PREFIX + accountNumber.replace(/-/g, '');
	if (transformedAccountNumber.length == 16) {
		transformedAccountNumber += DEFAULTS.LAST_DIGITS;
	}
	return transformedAccountNumber;
};

const lengthValidator = (value) => value.replace(/-/g, '').length == 13 || value.replace(/-/g, '').length == 21;

export default {
	components: {
		VueMaskedInput,
		VueErrorMessage,
		VueButton
	},
	data() {
		return {
			accountNumber: '',
			iban: null,
			submittedAccountNumber: ''
		};
	},
	props: {
		type: {
			type: String
		}
	},
	computed: {
		TYPES: () => TYPES,
		disableCalculationButton() {
			return !(this.accountNumber.replace(/-/g, '').length == 13 || this.accountNumber.replace(/-/g, '').length == 21) || !this.$v.accountNumber.cdv;
		}
	},
	methods: {
		removeHyphen() {
			if (this.accountNumber.replace(/-/g, '').length == 13 && this.accountNumber.endsWith('-')) {
				this.accountNumber = this.accountNumber.substring(0, this.accountNumber.length - 1);
			}
		},
		generateIban() {
			const transformedAccountNumber = transformInput(this.accountNumber);
			this.iban = composeIBAN({ countryCode: 'HU', bban: transformedAccountNumber });
			if (this.accountNumber.length == 14) {
				this.submittedAccountNumber = this.accountNumber + `-${DEFAULTS.LAST_DIGITS}`;
			} else if (this.accountNumber.length == 15) {
				this.submittedAccountNumber = this.accountNumber + DEFAULTS.LAST_DIGITS;
			} else {
				this.submittedAccountNumber = this.accountNumber;
			}
			this.$emit('iban-generated', { iban: this.iban, submittedAccountNumber: this.submittedAccountNumber.replace(/-/g, ' - ') });
		}
	},
	validations() {
		return {
			accountNumber: { required, lengthValidator, cdv }
		};
	},
	i18n: { messages }
};
